import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle } from 'lucide-react';

const awsFeatures = [
  'Faster development and deployment',
  'Scalable, high-performance solutions', 
  'Smarter data and AI integration',
  'Enhanced security and compliance'
];

const merixFeatures = [
  'Build advanced, scalable web and mobile platforms using top-tier technologies',
  'Accelerate the delivery of smart city, AI, and digital transformation projects across the GCC, Europe, and beyond',
  'Combine local market expertise with global engineering talent to offer clients world-class solutions with a regional edge'
];

const PartnershipAnnouncements = () => {
  return (
    <section className="py-24 bg-black">
      <div className="container mx-auto px-4">
        <div className="space-y-32">
          {/* AWS Partnership */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="relative"
          >
            <div className="max-w-5xl mx-auto">
              {/* Header - Left Aligned */}
              <div className="flex items-start gap-6 mb-12">
                <div className="w-20 h-20 bg-white rounded-2xl flex items-center justify-center flex-shrink-0">
                  <img
                    src="/AWS-logo.svg"
                    alt="AWS Logo"
                    className="w-16 h-16"
                  />
                </div>
                <div>
                  <span className="inline-block px-3 py-1 bg-accent/10 text-accent rounded-full text-sm font-medium mb-3">
                    Latest Partnership
                  </span>
                  <h3 className="text-3xl md:text-4xl font-display font-semibold text-white">
                    Solutions21 is now an AWS Partner!
                  </h3>
                </div>
              </div>

              {/* Content */}
              <div className="space-y-6">
                <p className="text-lg text-gray-300 leading-relaxed">
                  We're thrilled to announce that Solutions21 has joined the AWS Partner Network (APN) — 
                  a major leap forward in our mission to deliver exceptional high-quality products & services 
                  and forging deep outcome-driven partnerships.
                </p>
                
                <p className="text-lg text-gray-300 leading-relaxed">
                  At Solutions21, we've built a reputation for powering some of the Middle East's most iconic 
                  global events — Expo 2020 Dubai and COP28 — with cutting-edge technology that enhances 
                  experience, efficiency, and security. Now, by working jointly with AWS, we're supercharging 
                  our capabilities:
                </p>

                {/* Benefits List */}
                <div className="space-y-3 mt-8">
                  {awsFeatures.map((feature, index) => (
                    <motion.div
                      key={index}
                      initial={{ opacity: 0, x: -20 }}
                      whileInView={{ opacity: 1, x: 0 }}
                      viewport={{ once: true }}
                      transition={{ duration: 0.6, delay: index * 0.1 }}
                      className="flex items-center gap-3"
                    >
                      <CheckCircle className="w-5 h-5 text-accent flex-shrink-0" />
                      <span className="text-gray-300">{feature}</span>
                    </motion.div>
                  ))}
                </div>

                <p className="text-lg text-gray-300 leading-relaxed mt-8">
                  This collaboration isn't just about cloud — it's about creating a future where innovation 
                  moves at the speed of ambition.
                </p>
              </div>
            </div>
          </motion.div>

          {/* Merixstudio Partnership */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="relative"
          >
            <div className="max-w-5xl mx-auto">
              {/* Header - Left Aligned */}
              <div className="flex items-start gap-6 mb-12">
                <div className="w-20 h-20 bg-white rounded-2xl flex items-center justify-center flex-shrink-0">
                  <img
                    src="/Merixstudio-Logo.svg"
                    alt="Merixstudio Logo"
                    className="w-16 h-8 object-contain"
                  />
                </div>
                <div>
                  <span className="inline-block px-3 py-1 bg-accent/10 text-accent rounded-full text-sm font-medium mb-3">
                    Strategic Collaboration
                  </span>
                  <h3 className="text-3xl md:text-4xl font-display font-semibold text-white">
                    Growing Collaboration with Merixstudio
                  </h3>
                </div>
              </div>

              {/* Content */}
              <div className="space-y-6">
                <p className="text-lg text-gray-300 leading-relaxed">
                  At Solutions21, we believe the future of digital transformation is built on bold ideas — 
                  and the right partners to help realize them.
                </p>
                
                <p className="text-lg text-gray-300 leading-relaxed">
                  📣 We're excited to announce our growing collaboration with Merixstudio, a world-class 
                  development partner. Together, we've already delivered standout digital experiences, 
                  like the web and mobile platforms for Expo City Dubai. Now, we're joining forces to 
                  help our clients move faster, build smarter, and reach further.
                </p>

                <p className="text-lg text-gray-300 leading-relaxed">
                  This partnership will enable us to:
                </p>

                {/* Benefits List */}
                <div className="space-y-4">
                  {merixFeatures.map((feature, index) => (
                    <motion.div
                      key={index}
                      initial={{ opacity: 0, x: -20 }}
                      whileInView={{ opacity: 1, x: 0 }}
                      viewport={{ once: true }}
                      transition={{ duration: 0.6, delay: index * 0.1 }}
                      className="flex items-start gap-3"
                    >
                      <CheckCircle className="w-5 h-5 text-accent flex-shrink-0 mt-0.5" />
                      <span className="text-gray-300">{feature}</span>
                    </motion.div>
                  ))}
                </div>

                <p className="text-lg text-gray-300 leading-relaxed">
                  In short: We're combining visionary ideas with rock-solid execution — helping our clients scale 
                  and succeed with confidence.
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default PartnershipAnnouncements;